export default [{
  path: '/form',
  name: 'Form',
  component: (resolve) => require(['components/views/Cadastros'], resolve),
  meta: { title: 'Formulário', icon: 'icon-paper' }
}, {
  path: '/upload',
  name: 'upload',
  component: (resolve) => require(['components/views/Upload'], resolve),
  meta: { title: 'Upload', icon: 'h-icon-upload' }
}, {
  path: '/notificacao',
  name: 'notificacao',
  component: (resolve) => require(['components/views/notificacao/Index'], resolve),
  meta: { title: 'Notificação' }
}, {
  path: '/notificacao/:id',
  name: 'notificacao-mensagem',
  component: (resolve) => require(['components/views/notificacao/Mensagem'], resolve),
  meta: { title: 'Notificação Detalhe' }
}, {
  path: '/integracoes',
  name: 'integracoes-marketplace',
  component: (resolve) => require(['components/views/integracoes/Index'], resolve),
  meta: { title: 'Integrações' }
}, {
  path: '/integracoes/fxdata/:id?',
  name: 'integracoes-fxdata',
  component: (resolve) => require(['components/views/integracoes/configuracao/Fxdata'], resolve),
  meta: { title: 'Integrações - FX Data' }
}, {
  path: '/integracoes/pdvfinancas360/:id?',
  name: 'integracoes-financas360',
  component: (resolve) => require(['components/views/integracoes/configuracao/Financas360'], resolve),
  meta: { title: 'Integrações - Finanças 360' }
}, {
  path: '/integracoes/chamadas',
  name: 'integracoes-chamadas',
  component: (resolve) => require(['components/views/integracoes/Chamadas'], resolve),
  meta: { title: 'Integrações - Chamadas' }
}, {
  path: '/integracoes/chamar-servico/fxdata/:id?',
  name: 'integracoes-chamarservico-fxdata',
  component: (resolve) => require(['components/views/integracoes/chamarServico/Fxdata'], resolve),
  meta: { title: 'Integrações - Chamar Serviço - FX Data' }
}, {
  path: '/integracoes/chamar-servico/pdvfinancas360/:id?',
  name: 'integracoes-chamarservico-financas360',
  component: (resolve) => require(['components/views/integracoes/chamarServico/Financas360'], resolve),
  meta: { title: 'Integrações - Chamar Serviço - Finanças 360' }
}, {
  path: '/integracoes/configuradas',
  name: 'integracoes-configuradas',
  component: (resolve) => require(['components/views/integracoes/Configuradas'], resolve),
  meta: { title: 'Integrações - Configuradas' }
}, {
  path: '/metas/exportar-modelo',
  name: 'metas-exportar-modelo',
  component: (resolve) => require(['components/views/metas/ExportarModelo'], resolve),
  meta: { title: 'Metas - Exportar Modelo' }
}, {
  path: '/metas/configurar',
  name: 'metas-configurar',
  component: (resolve) => require(['components/views/metas/ConfigurarMetas'], resolve),
  meta: { title: 'Metas - configurar' }
}, {
  path: '/metas/importar-modelo',
  name: 'metas-importar-modelo',
  component: (resolve) => require(['components/views/metas/ImportarModelo'], resolve),
  meta: { title: 'Metas - Importar Modelo' }
}, {
  path: '/metas/estagio-configuracao',
  name: 'metas-estagio-configuracao',
  component: (resolve) => require(['components/views/metas/EstagioConfiguracao'], resolve),
  meta: { title: 'Metas - Estágio Configuração' }
}, {
  path: '/arquivos',
  name: 'arquivos-status',
  component: (resolve) => require(['components/views/arquivos/Index'], resolve),
  meta: { title: 'Arquivos' }
}, {
  path: '/arquivos/upload',
  name: 'arquivos-upload',
  component: (resolve) => require(['components/views/arquivos/Upload'], resolve),
  meta: { title: 'Arquivos - Upload' }
}, {
  path: '/arquivos/:id',
  name: 'arquivos-detalhe',
  component: (resolve) => require(['components/views/arquivos/Detalhe'], resolve),
  meta: { title: 'Arquivos - Detalhe' }
}, {
  path: '/vendas',
  name: 'vendas',
  component: (resolve) => require(['components/views/vendas/Index'], resolve),
  meta: { title: 'Vendas' }
}, {
  path: '/relatorios',
  name: 'relatorios',
  component: (resolve) => require(['components/views/relatorios/Index'], resolve),
  meta: { title: 'Relatórios' }
},
{
  path: '/regras',
  name: 'regras',
  component: (resolve) => require(['components/views/regras-usuario/Index'], resolve),
  meta: { title: 'Regras de usuário' }
},
{
  path: '/vendedores',
  name: 'vendedores',
  component: (resolve) => require(['components/views/vendedores/Index'], resolve),
  meta: { title: 'Vendedores' }
},
{
  path: '/empresas',
  name: 'empresas',
  component: (resolve) => require(['components/views/Empresas/Index'], resolve),
  meta: { title: 'Empresas' }
},
{
  path: '/revendedores',
  name: 'revendedores',
  component: (resolve) => require(['components/views/revendedores/Index'], resolve),
  meta: { title: 'Revendedores' }
}
];
